export function formattedPlayerName(team_name, player_name) {
	if (team_name === undefined || player_name === undefined) return "";

	if (typeof player_name !== 'string') return player_name

	let player_name_list = player_name.split(" ")
	
	const last_name = player_name_list[player_name_list.length - 1]

	return team_name === "Purdue Football" ? last_name : player_name;
}
